import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { CheckboxWithController } from 'components/Common/Form/MuiInputs';
import { useFormContext } from 'react-hook-form';

const PLAN_OPTIONS = [
    {
        id: 'approveHmo',
        title: 'Medicare Health Maintenance Organization (HMO)',
        description:
            'A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage ' +
            'and sometimes covers Part D prescription drug coverage. In most HMOs, you can only get your ' +
            'care from doctors or hospitals in the plan’s network (except in emergencies).',
    },
    {
        id: 'approvePpo',
        title: 'Medicare Preferred Provider Organization (PPO) Plan',
        description:
            'A Medicare Advantage Plan that provides all Original Medicare Part A and Part B health coverage ' +
            'and sometimes covers Part D prescription drug coverage. PPOs have network doctors and ' +
            'hospitals, but you can also use out-of-network providers, usually at a higher cost.',
    },
    {
        id: 'approvePos',
        title: 'Medicare Point of Service (POS) Plan',
        description:
            'A type of Medicare Advantage Plan available in a local or regional area which combines the ' +
            'best feature of an HMO with an out-of-network benefit. Like the HMO, members are required to ' +
            'designate an in-network physician to be the primary health care provider. You can use doctors, ' +
            'hospitals, and providers outside of the network for an additional cost.',
    },
    {
        id: 'approveSnp',
        title: 'Medicare Special Needs Plan (SNP)',
        description:
            'A Medicare Advantage Plan that has a benefit package designed for people with special health ' +
            'care needs. Examples of the specific groups served include people who have both Medicare ' +
            'and Medicaid, people who reside in nursing homes, and people who have certain chronic ' +
            'medical conditions.',
    },
];
const PlanCoverageDisclosureOptions = () => {
    const {
        formState: { errors },
    } = useFormContext();

    return (
        <Box sx={{ mb: 3 }}>
            <Box
                sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        px: { xs: 2, sm: 3 },
                        py: 2,
                        backgroundColor: 'grey.50',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography
                        variant="overline"
                        sx={{ color: 'text.secondary', fontWeight: 700 }}
                    >
                        Medicare Advantage plans (Part C) and cost plans
                    </Typography>
                </Box>
                {PLAN_OPTIONS.map((plan) => (
                    <Box
                        key={plan.id}
                        sx={{
                            px: { xs: 2, sm: 3 },
                            py: 2,
                            '& + &': {
                                borderTop: '1px solid',
                                borderColor: 'divider',
                            },
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={1}>
                                <CheckboxWithController
                                    controllerProps={{ name: plan.id }}
                                    labelProps={{
                                        label: '',
                                    }}
                                />
                            </Grid>
                            <Grid item xs={10} sx={{display: 'flex', alignItems: 'center'}}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{ fontWeight: 600 }}
                                >
                                    {plan.title}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Typography
                            variant="body2"
                            sx={{
                                mt: 0.5,
                                color: 'text.secondary',
                                lineHeight: 1.6,
                            }}
                        >
                            {plan.description}
                        </Typography>
                    </Box>
                ))}
            </Box>
            {errors?.hasInitial?.message && (
                <Alert severity="error" sx={{ width: '100%' }}>
                    <AlertTitle>
                        {errors.hasInitial?.message as string}
                    </AlertTitle>
                </Alert>
            )}
        </Box>
    );
};
export default PlanCoverageDisclosureOptions;
